<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ t("Explorer Options") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" color="light">
    <ion-item color="primary">
      <ion-label>
        {{ t("Main Game Source") }}
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-radio-group :value="main" @ionChange="radioChange($event,'main')">
        <ion-row>
          <ion-col>
            <ion-radio value="lichess" aria-label="lichess" label-placement="end">
              Lichess
            </ion-radio>
          </ion-col>
          <div v-if="props.isSubscriber">
          <ion-col>
            <ion-radio value="user" aria-label="user" label-placement="end">
              {{ t("Yours") }}
            </ion-radio>
          </ion-col>
        </div>
          <ion-col>
            <ion-radio value="master" aria-label="master" label-placement="end">
              {{ t("Masters") }}
            </ion-radio>
          </ion-col>
        </ion-row>
      </ion-radio-group>
    </ion-item>
    <ion-item>
        <ion-label>
          <h2 :class="{ 'dim-text' : main != 'lichess'}">Lichess {{ t("Rating") }}:<br>{{ mainMinNumber }} {{ t("to") }} {{  mainMaxNumber }}</h2>
        </ion-label>
        <ion-range id="main_range" :disabled="main != 'lichess'" :pin="true" aria-label="Dual Knobs Range" 
          :dual-knobs="true" :min="800" :max="2550"  
                :step="50"   v-model="mainValue"
                @ionKnobMoveStart="onIonKnobMove"
                @ionKnobMoveEnd="onIonKnobMove"
      >
      </ion-range>
    </ion-item>
    
    <!-- Compare  -->

    <ion-item color="secondary">
      <ion-label>
        {{  comparisonLabel }}
      </ion-label>
    </ion-item>
    <div v-if="props.isSubscriber">
    <ion-item>
      <ion-radio-group :value="compare" @ionChange="radioChange($event,'compare')">
        <ion-row>
          <ion-col>
            <ion-radio value="none" aria-label="none" label-placement="end">
              {{ t("None") }}
            </ion-radio>
          </ion-col>
          <ion-col>
            <ion-radio value="lichess" aria-label="lichess" label-placement="end">
              Lichess
            </ion-radio>
          </ion-col>
          <ion-col>
            <ion-radio value="user" aria-label="user" label-placement="end">
              {{ t("Yours") }}
            </ion-radio>
          </ion-col>
          <ion-col>
            <ion-radio value="master" aria-label="master" label-placement="end">
              {{ t("Masters") }}
            </ion-radio>
          </ion-col>
       
        </ion-row>
      </ion-radio-group>
    </ion-item>
    <ion-item>
        <ion-label>
          <h2 :class="{ 'dim-text' : compare != 'lichess'}">Lichess {{ t("Rating") }}:<br>{{ compareMinNumber }} {{ t("to") }} {{  compareMaxNumber }}</h2>
        </ion-label>
        <ion-range id="compare_range" :disabled="compare != 'lichess'" :pin="true" aria-label="Dual Knobs Range" 
          :dual-knobs="true" :min="800" :max="2550"  
                :step="50"   v-model="compareValue"
                @ionKnobMoveStart="onIonKnobMove"
                @ionKnobMoveEnd="onIonKnobMove"
      >
      </ion-range>
    </ion-item>
  </div>

    <!-- show Scores -->

    <ion-item>
      <ion-checkbox label-placement="start" @ionChange="showScores = !showScores" :checked="showScores">
        {{ t("Show Stockfish Scores") }}
      </ion-checkbox>
    </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRow,
    IonCol,
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonCheckbox,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t } from '@/composables/translateText.js'

  const props = defineProps({
    mainMin : Number,
    mainMax : Number,
    compareMin : Number,
    compareMax : Number,
    mainSource : String,
    compareSource : String,
    showScores : Boolean,
    isSubscriber : Boolean
	})

  const name = ref();

  const comparisonLabel = ref((props.isSubscriber) ? t("Comparison Game Source") : t("Comparisons Reserved for Subscribers"))

  var mainValue = {lower: props.mainMin, upper: props.mainMax}
  var compareValue = {lower: props.compareMin, upper: props.compareMax}
  const mainMinNumber = ref(mainValue.lower)
  const mainMaxNumber = ref(mainValue.upper)
  const compareMinNumber = ref(compareValue.lower)
  const compareMaxNumber = ref(compareValue.upper)
  const main = ref(props.mainSource)
  const compare = ref(props.compareSource)
  const showScores = ref(props.showScores)

  //console.log("PROPS IN MODAL",props)
  const cancel = () => modalController.dismiss(null, 'cancel');

  function confirm() {
    var result = { 
      mainMin : mainMinNumber.value,
      mainMax : mainMaxNumber.value,
      compareMin : compareMinNumber.value,
      compareMax : compareMaxNumber.value,
      mainSource : main.value,
      compareSource : compare.value,
      showScores : showScores.value
    }

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function onIonKnobMove({ detail }) {
    const customEvent = arguments[0]
    const name = customEvent.srcElement.id
    if (name == "main_range") {
      mainMinNumber.value = detail.value.lower
      mainMaxNumber.value = detail.value.upper
    }
    else {
      compareMinNumber.value = detail.value.lower
      compareMaxNumber.value = detail.value.upper
    }
  }

  function radioChange(ev,whichSet) {
    //console.log("radio Change",ev.detail,whichSet)
    //console.log('Current value:', JSON.stringify(ev.detail.value));
    if (whichSet == "main")
      main.value = ev.detail.value
    else
      compare.value = ev.detail.value
  }


</script>

<style scoped>

.item{
  margin:10px auto;
}

.dim-text {
  color : dimgray;
}

ion-radio::part(container) {
    width: 30px;
    height: 30px;

    border-radius: 8px;
    border: 2px solid #ddd;
  }

  ion-radio::part(mark) {
    background: none;
    transition: none;
    transform: none;
    border-radius: 0;
  }

  ion-radio.radio-checked::part(container) {
    background: #6815ec;
    border-color: transparent;
  }

  ion-radio.radio-checked::part(mark) {
    width: 6px;
    height: 10px;

    border-width: 0px 2px 2px 0px;
    border-style: solid;
    border-color: #fff;

    transform: rotate(45deg);
  }
</style>
